import { type ReactNode } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

function BarSkeleton({ heightClass }: { heightClass: string }): ReactNode {
  return (
    <div className="space-y-1.5">
      <div className="flex items-baseline justify-between">
        <Skeleton className="h-[16px] w-24" />
        <Skeleton className="h-[13px] w-32" />
      </div>
      <Skeleton className={`${heightClass} w-full rounded-lg`} />
    </div>
  );
}

export function ProgressSkeleton(): ReactNode {
  return (
    <div className="space-y-lg">
      <BarSkeleton heightClass="h-4" />
      <BarSkeleton heightClass="h-3" />
    </div>
  );
}
